import LoanQuery from './queries/LoanQuery'
import React, { PureComponent } from 'react'
import { graphql } from 'react-apollo'
import Loader from '../common/Loader'
import Error from '../common/Error'
import Tabs from './Tabs'

class QuestionsWrapper extends PureComponent {
  render() {
    const { props: { data, isPaycheckProtection, isEditable, isEligibility } } = this
    const { loading, error } = data

    if (loading) {
      return <Loader number={4} />
    }

    if (error) {
      return <Error />
    }

    const { loan } = data

    return (
      <Tabs
        loan={loan}
        isPaycheckProtection={isPaycheckProtection}
        isEditable={isEditable}
        isEligibility={isEligibility}
      />
    )
  }
}

export default graphql(LoanQuery, {
  options: ({ loanId }) => ({
    variables: {
      loanId
    }
  })
})(QuestionsWrapper)
